export interface IApplicationState {
    startRandomWild: boolean
    updateSymbol: boolean
    symbolPosition: any
    featureComplete: any
    updateDisplayWinDuration: any
    wildPosition: any
}

const initialState: IApplicationState = {
    startRandomWild: false,
    updateSymbol: false,
    featureComplete: false,
    updateDisplayWinDuration: 1,
    symbolPosition: [],
    wildPosition: []

};

export enum actionTypes {
    START_RANDOMWILD = '@@randomWild/START_RANDOMWILD',
    UPDATE_SYMBOL = '@@randomWild/UPDATE_SYMBOL',
    SYMBOL_POSITION = '@@randomWild/SYMBOL_POSITION',
    WILD_POSITION = '@@randomWild/WILD_POSITION',
    UPDATED_DURATION = '@@randomWild/UPDATED_DURATION',
    RESET = '@@randomWild/RESET',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { symbolPosition, duration, wildPosition } = action;
    switch (action.type) {
        case actionTypes.START_RANDOMWILD:
            return {
                ...state, startRandomWild: true
            };
        case actionTypes.UPDATE_SYMBOL:
            return {
                ...state, updateSymbol: true
            };
        case actionTypes.SYMBOL_POSITION:
            return {
                ...state, symbolPosition: symbolPosition
            };
        case actionTypes.WILD_POSITION:
            return {
                ...state, wildPosition: wildPosition
            };
        case actionTypes.UPDATED_DURATION:
            return {
                ...state, updateDisplayWinDuration: duration
            };
        case actionTypes.RESET:
            return {
                ...state, startRandomWild: false
                , updateSymbol: false
                , symbolPosition: []
            };


        default:
            return state;
    }
}

export const actions = {
    startRandomWild: (): any => ({ type: actionTypes.START_RANDOMWILD }),
    updateRandomWildSymbol: (): any => ({ type: actionTypes.UPDATE_SYMBOL }),
    setRandomWildSymbol: (symbolPosition: any): any => ({ type: actionTypes.SYMBOL_POSITION, symbolPosition }),
    setWildSymbolPosition: (wildPosition: any): any => ({ type: actionTypes.WILD_POSITION, wildPosition }),
    setUpdatedWinDisplayDuration: (duration: any): any => ({ type: actionTypes.UPDATED_DURATION, duration }),
    resetRandomWild: (): any => ({ type: actionTypes.RESET }),
};
